module.exports = __webpack_public_path__ + "static/media/logo_draft.ace5ff64.svg";